export const getFormsOptions = (forms) =>
  (forms || []).map(({ Name, Id }) => ({ value: Id, name: Name }));
